<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte'
	import { upgradeHelpText } from '$lib/stores/upgrade'
	import Modal from '$lib/components/ModalOverlay.svelte'
	import { LockClosedIcon } from '@rgossiaux/svelte-heroicons/outline'
	import Benefits from '$lib/components/Benefits.svelte'
	import { page } from '$app/stores'
	import { trpc } from '$lib/trpc/client'
	import { TRPCClientError } from '@trpc/client'
	import type { RouterOutputs } from '$lib/trpc/routes'
	
	let benefits: RouterOutputs['lists']['read'] | undefined = undefined

	const dispatch = createEventDispatcher()

	export let open: boolean

	onMount(async () => {
		try {
			console.log('loading benefits')
			benefits = await trpc($page).lists.read.query( { key: 'benefits_paid'} )
		} catch (err) {
			if (err instanceof TRPCClientError) {
				console.log("ERROR IS HERE", err)
			} else {
				throw err
			}
		}
	})

	const close = () => {
		open = false
		dispatch('close')
	}
</script>

<div class="z-50">
	<Modal {open} on:close={close}>
		<svelte:fragment slot="title">Upgrade to paid plan</svelte:fragment>
		<svelte:fragment slot="body">
			<div class="flex flex-col space-y-4 p-4 text-xl">
				<div class="mt-4 flex space-x-2 items-center">
					<LockClosedIcon class="h-8" />
					<div class="text-6xl">
						{$upgradeHelpText}
					</div>
				</div>
				<p class="my-4">The premium paid version of Bookjournal includes many features, including:</p>
				<Benefits {benefits} />
				<p class="hidden mt-4">
					Subscribe and access all our features as well as get early access to select new features.
				</p>
				<p class="mt-4" />
			</div>
		</svelte:fragment>
		<svelte:fragment slot="buttons">
			<a href="/upgrade" class="btn btn-app">Find out more</a>
		</svelte:fragment>
	</Modal>
</div>
